/**
 * Open-redirect-safe parser for the `?next=` query parameter (T-1-11 mitigation).
 *
 * The `next` value must be a relative path (starts with `/`, not `//`, no scheme).
 * Anything else falls back to `/courses` (Phase 2 plan 02-03 / CONTEXT D-37 —
 * the public-shell home is the catalog, not the deprecated `/dashboard`).
 */
export const DEFAULT_NEXT = "/courses";

export function safeNext(raw: string | null | undefined, defaultTarget: string = DEFAULT_NEXT): string {
  if (!raw) return defaultTarget;
  const value = raw.trim();
  if (value.length === 0) return defaultTarget;
  if (value.startsWith("//")) return defaultTarget;
  if (!value.startsWith("/")) return defaultTarget;
  if (value.includes("\\")) return defaultTarget;
  return value;
}

